import { auth, notFound } from 'routing/common';

export default [...auth, ...notFound];
